import { createRouter, createWebHistory } from 'vue-router'

// 路由懒加载
const Home = () => import('@/views/Home.vue')
const Products = () => import('@/views/Products.vue')
const Solutions = () => import('@/views/Solutions.vue')
const DataCenter = () => import('@/views/DataCenter.vue')
const About = () => import('@/views/About.vue')
const Contact = () => import('@/views/Contact.vue')
const Activity = () => import('@/views/Activity.vue')
const News = () => import('@/views/News.vue')
const Docs = () => import('@/views/Docs.vue')

// 产品详情页
const ServerDetail = () => import('@/views/products/ServerDetail.vue')
const CloudDetail = () => import('@/views/products/CloudDetail.vue')
const SSLDetail = () => import('@/views/products/SSLDetail.vue')
const DomainDetail = () => import('@/views/products/DomainDetail.vue')

// 法律条款页
const Terms = () => import('@/views/legal/Terms.vue')
const Privacy = () => import('@/views/legal/Privacy.vue')
const DMCA = () => import('@/views/legal/DMCA.vue')
const AUP = () => import('@/views/legal/AUP.vue')
const DSA = () => import('@/views/legal/DSA.vue')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '首页',
      description: '星云全球云服务平台，提供专业的云服务器、物理服务器、服务器托管等服务'
    }
  },
  {
    path: '/products',
    name: 'Products',
    component: Products,
    meta: {
      title: '产品',
      description: '查看我们的全部产品与服务'
    },
    children: [
      {
        path: 'server/:type?',
        name: 'ServerDetail',
        component: ServerDetail,
        meta: {
          title: '物理服务器'
        }
      },
      {
        path: 'cloud/:type?',
        name: 'CloudDetail',
        component: CloudDetail,
        meta: {
          title: '云服务器'
        }
      },
      {
        path: 'ssl',
        name: 'SSLDetail',
        component: SSLDetail,
        meta: {
          title: 'SSL证书'
        }
      },
      {
        path: 'domain',
        name: 'DomainDetail',
        component: DomainDetail,
        meta: {
          title: '域名注册'
        }
      }
    ]
  },
  {
    path: '/solutions',
    name: 'Solutions',
    component: Solutions,
    meta: {
      title: '解决方案',
      description: '专业的企业级解决方案'
    }
  },
  {
    path: '/datacenter/:dc?',
    name: 'DataCenter',
    component: DataCenter,
    meta: {
      title: '数据中心',
      description: '全球数据中心介绍'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title: '关于我们',
      description: '了解星云全球'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: {
      title: '联系我们',
      description: '联系星云全球'
    }
  },
  {
    path: '/activity',
    name: 'Activity',
    component: Activity,
    meta: {
      title: '最新活动',
      description: '查看最新优惠活动'
    }
  },
  {
    path: '/news',
    name: 'News',
    component: News,
    meta: {
      title: '新闻公告',
      description: '最新新闻与公告'
    }
  },
  {
    path: '/docs',
    name: 'Docs',
    component: Docs,
    meta: {
      title: '文档中心',
      description: '产品文档与教程'
    }
  },
  {
    path: '/legal/terms',
    name: 'Terms',
    component: Terms,
    meta: {
      title: '服务条款'
    }
  },
  {
    path: '/legal/privacy',
    name: 'Privacy',
    component: Privacy,
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: '/legal/dmca',
    name: 'DMCA',
    component: DMCA,
    meta: {
      title: 'DMCA政策'
    }
  },
  {
    path: '/legal/tos',
    name: 'TOS',
    component: Terms,
    meta: {
      title: '服务条款'
    }
  },
  {
    path: '/legal/privacy-policy',
    name: 'PrivacyPolicy',
    component: Privacy,
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: '/legal/acceptable-use-policy',
    name: 'AcceptableUsePolicy',
    component: AUP,
    meta: {
      title: '可接受使用政策'
    }
  },
  {
    path: '/legal/dsa-policy',
    name: 'DSAPolicy',
    component: DSA,
    meta: {
      title: 'DSA政策'
    }
  },
  {
    path: '/legal/dmca-policy',
    name: 'DMCAPolicy',
    component: DMCA,
    meta: {
      title: 'DMCA政策'
    }
  },
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('@/views/About.vue'),
    meta: {
      title: '登录/注册'
    }
  },
  {
    path: '/cart/order',
    name: 'CartOrder',
    component: () => import('@/views/Products.vue'),
    meta: {
      title: '订单'
    }
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () => import('@/views/Products.vue'),
    meta: {
      title: '购物车'
    }
  },
  {
    path: '/partner',
    name: 'Partner',
    component: About,
    meta: {
      title: '合作伙伴'
    }
  },
  {
    path: '/company',
    name: 'Company',
    component: About,
    meta: {
      title: '公司介绍'
    }
  },
  {
    path: '/history',
    name: 'History',
    component: About,
    meta: {
      title: '发展历程'
    }
  },
  {
    path: '/joinus',
    name: 'JoinUs',
    component: Contact,
    meta: {
      title: '加入我们'
    }
  },
  {
    path: '/page/joinus',
    redirect: '/joinus'
  },
  {
    path: '/page/histroy',
    redirect: '/history'
  },
  {
    path: '/histroy',
    redirect: '/history'
  },
  {
    path: '/page/company',
    redirect: '/company'
  },
  {
    path: '/page/contact',
    redirect: '/contact'
  },
  {
    path: '/page/activity',
    redirect: '/activity'
  },
  {
    path: '/page/partner',
    redirect: '/partner'
  },
  {
    path: '/dc/:slug',
    name: 'DataCenterDetail',
    component: DataCenter,
    meta: {
      title: '数据中心'
    }
  },
  {
    path: '/announcements',
    name: 'Announcements',
    component: News,
    meta: {
      title: '公告'
    }
  },
  {
    path: '/download',
    name: 'Download',
    component: Docs,
    meta: {
      title: '下载'
    }
  },
  {
    path: '/submitticket',
    name: 'SubmitTicket',
    component: Contact,
    meta: {
      title: '提交工单'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 路由守卫 - SEO优化
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - 95008星云全球`
  }
  
  // 设置meta description
  if (to.meta.description) {
    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute('content', to.meta.description)
    }
  }
  
  next()
})

export default router